import Vue from 'vue'
import * as config from './config.js'
import _ from 'lodash'
import { CNPJ_MASK } from './masks'

Vue.mixin({
  computed: {
    cnpjMask () {
      return CNPJ_MASK
    }
  },
  methods: {
    graphQL (data) {
      return this.$http.post(config.apiDomain + 'graphql', data)
    },
    isMobile () {
      return (window.innerWidth < 992)
    },
    isCompanyOwner () {
      return this.user.is_company_owner
    },
    isCompanyAdmin () {
      return (this.user.is_company_owner || this.user.employee.type === 1)
    },
    isCompanyOperador () {
      return this.user.employee.type === 2
    },
    isCompanyFinancial () {
      return this.user.employee.type === 3
    },
    subscribeChannel () {
      if (this.user && this.user.company && this.user.company.hash) {
        window.Channel = window.Echo.channel(this.user.company.hash)
        window.Channel.alertPanel = window.Echo.channel('alert-panel-notification')
        window.Echo.channel('master').listen('.refresh', (e) => {
          window.location.reload(true)
        })
      }
    },
    unsubscribeChannel () {
      if (this.user && this.user.company && this.user.company.hash) {
        window.Echo.leave(this.user.company.hash)
        window.Echo.leave('alert-panel-notification')
      }
      window.Echo.leave('master')
    },
    imageUrl (path, resize = false) {
      let extension = path.substring(path.lastIndexOf('.') + 1)
      let fileName = path.substring(0, path.lastIndexOf('.'))
      let template = 'original'
      if (resize) {
        fileName += '-resize(' + resize + ')'
        template = 'resize'
      }
      let url = fileName + '.' + extension
      return config.cdnURL + 'image/' + template + '/' + url
    },
    cdn (path) {
      return config.cdnURL + 'storage/' + path
    },
    getColor: description => {
      let colors = []
      colors['available'] = '#2ab27b'
      colors['reserved'] = '#cbb956'
      colors['maintenance'] = '#bf262a'
      colors['rented'] = '#189ce2'
      return colors[description]
    },
    isMobilePhone: str => {
      if (!str || str === '') return false
      return (str.length === 14)
    },
    phoneNumber: str => {
      if (!str || str === '') return ''
      str = str.replace('_', '')
      if (str.length === 13) {
        let num = str.charAt(8)
        str = str.replace(num + '-', '-' + num)
      }
      return str
    },
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    strUpperCase: str => str.toUpperCase(),
    limit: (value, size) => {
      if (!value) return ''
      if (value.length < size) return value
      return value.substring(0, size) + '...'
    },
    time: (value, full = true) => {
      if (!value || value === '') return '-'
      if (full) {
        return window.moment(value, 'DD/MM/YY à\\s H\\hm').calendar(null, {
          sameDay: '[Hoje] [às] H:mm',
          nextDay: '[Amanhã] [às] H:mm',
          nextWeek: 'DD/MM/YY [às] H:mm',
          lastDay: '[Ontem] [às] H:mm',
          lastWeek: 'DD/MM/YY [às] H:mm',
          sameElse: 'DD/MM/YY [às] H:mm'
        })
      } else {
        return window.moment(value, 'DD/MM/YYYY').calendar(null, {
          sameDay: '[Hoje]',
          nextDay: '[Amanhã]',
          nextWeek: 'DD/MM/YY',
          lastDay: '[Ontem]',
          lastWeek: 'DD/MM/YY',
          sameElse: 'DD/MM/YY'
        })
      }
    },
    money: (value, allowZero = true, free = false) => {
      if (isNaN(value)) return '- -'
      if (parseFloat(value) === 0 && allowZero && free) return 'Grátis'
      if (parseFloat(value) === 0 && !allowZero) return '- -'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      }).format(value)
    },
    rentType: (value) => {
      let types = [null, 'Diária', 'Semanal', 'Quinzenal', 'Mensal']
      return types[value]
    },
    periodName: (value) => {
      let types = [null, 'Manhã', 'Tarde']
      return types[value]
    },
    rentPeriod (type) {
      return [null, 'dia', 'semana', 'quinzena', 'mês'][type]
    },
    rentPeriods (periods, type) {
      if (periods === 1) {
        return [null, 'dia', 'semana', 'quinzena', 'mês'][type]
      } else if (periods > 1) {
        return [null, 'dias', 'semanas', 'quinzenas', 'mêses'][type]
      }
      return ''
    },
    paymentMethod: (value) => {
      let text = ''
      switch (value) {
        case 'cash':
          text = 'DINHEIRO'
          break
        case 'boleto':
          text = 'BOLETO'
          break
        case 'credit_card':
          text = 'C. CRÉDITO'
          break
        default:
          text = '- -'
      }
      return text
    },
    linkRegistration (client = false) {
      if (this.user) {
        let domain = config.displayURL.replace('//', '//' + this.user.company.display_name + '.')
        return domain + 'registration' + (client ? '/' + client.id + '?hash=' + client.hash : '')
      }
    },
    whatsappLink (tel, client) {
      let text = '&text='
      let message = 'Acesse o link abaixo e complete seu cadastro na *' + this.user.company.fantasy_name + '*.\n\n'
      message += 'Para que você consiga clicar no link, é necessário adicionar o nosso número aos seus contatos.\n\n'
      message += this.linkRegistration(client)
      window.open(this.urlToWhatsapp() + this.phoneToWhatsapp(tel) + text + encodeURIComponent(message), '_blank')
    },
    whatsappApprovedRegistration (tel) {
      let text = '&text='
      let message = '*Parabéns!*\n\nO seu cadastro foi aprovado na *' + this.user.company.fantasy_name + '*.\n\nSeja bem vindo à nossa locadora.'
      window.open(this.urlToWhatsapp() + this.phoneToWhatsapp(tel) + text + encodeURIComponent(message), '_blank')
    },
    whatsappOpen (tel, message) {
      message = message || ''
      window.open(this.urlToWhatsapp() + this.phoneToWhatsapp(tel) + '&text=' + encodeURIComponent(message), '_blank')
    },
    whatsappSupport (tel, type, company, client) {
      let text = '&text='
      let typeSearch = type === 'fraud' ? 'Anti-Fraude' : 'Análise de crédito'
      let companyName = company
      let clientName = client
      let message = 'Olá Loca.shop, boa tarde! *\n\nOcorreu um erro na consulta ' + typeSearch + ' para locadora ' + companyName + '\nao consulta o cliente ' + clientName + '.'
      window.open(this.urlToWhatsapp() + this.phoneToWhatsapp(tel) + text + encodeURIComponent(message), '_blank')
    },
    whatsappInfoDisplay (tel, company) {
      let text = '?text='
      let companyName = company
      let message = 'Olá Loca.shop. \n\nGostaria de saber mais informações sobre o Display - Catálogo de produtos. \n\n Locadora: ' + companyName + '.'
      window.open(this.urlToWhatsapp() + this.phoneToWhatsapp(tel) + text + encodeURIComponent(message), '_blank')
    },
    urlToWhatsapp () {
      return 'https://wa.me/'
    },
    phoneToWhatsapp (tel) {
      return '55' + tel.replace(/\D/g, '')
    },
    withoutAccents (text) {
      return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    hasPostcode (postcode, client) {
      let has = _.find(client.addresses, (a) => {
        return (a.postcode === postcode)
      })
      return (has)
    },
    documentDefault (value) {
      return value.replace(/[^0-9]/g, '')
    },
    getNameRelationship (relationship, document) {
      let data = ''
      _.forEach(relationship, element => {
        if (document === element.document) {
          data = element.name
        }
      })
      return data
    },
    getStatusCompanyPix (status) {
      if (status === 'waiting_payment') {
        return 1
      } else if (status === 'paid') {
        return 2
      } else if (status === 'user_changed_payment') {
        return 3
      } else {
        return 4
      }
    },
    getInfoFraud (client, level, info) {
      if (client.cnpj) {
        if (level === 'level1') {
          return info.fraud.level1PJ
        } else if (level === 'level2') {
          return info.fraud.level2PJ
        } else {
          return info.fraud.level3PJ
        }
      } else {
        if (level === 'level1') {
          return info.fraud.level1PF
        } else if (level === 'level2') {
          return info.fraud.level2PF
        } else {
          return info.fraud.level3PF
        }
      }
    },
    getInfoCredit (client, score = false, info) {
      if (client.cnpj) {
        return info.credit.level1PJ
      } else if (score) {
        return info.credit.score
      } else {
        return info.credit.level1PF
      }
    },
    getCertificateTypes () {
      let data = {
        'pf_antecedentes': 'Certidão Antecedentes Criminais - Polícia Federal',
        'pc_antecedentes': 'Certidão Antecedentes Criminais - Polícia Civil - MG',
        'cert_debt_absence_by_state': 'CND Estadual',
        'pgfn': 'CND Federal',
        'fgts': 'Certidão FGTS'
      }
      return data
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixin.js